import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_TITLE = "Besöksguiden - Nordiska museet";

const formatSlug = (slug) => {
    const withSpaces = slug.replaceAll('-', ' ');
    return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
};

export default function DocumentTitle() {
    const { pathname } = useLocation();

    useEffect(() => {
        const parts = pathname.split('/').filter(Boolean);

        if (parts.length === 0) {
            document.title = BASE_TITLE;
            return;
        }

        const last = parts[parts.length - 1];

        if (last === 'readmore' && parts.length >= 2) {
            const exhibition = formatSlug(parts[parts.length - 2]);
            document.title = `${exhibition} - Readmore - Nordiska museet`;
        } else {
            const title = formatSlug(last);
            document.title = `${title} - Nordiska museet`;
        }
    }, [pathname]);

    return null;
}
